import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {CrewActivitiesPresenter} from './CrewActivitiesPresenter';
import {PresenterProps, withPresenter} from '../../../../../../Support/with_presenter';
import {NetworkRequestStatusView} from '../../../../../Components/Utils/NetworkRequestStatusView';
import {Loader} from '../../../../../Components/Utils/Loader';
import {format} from 'date-fns';
import {formatDistanceCompact} from '../../../../../Support/Formatting/formatDistance';
import {Distance} from '../../../../../../Domain/Distance';
import {Link} from 'react-router-dom';
import {FullCrew} from '../../../../../../Models/Crew';

interface OwnProps {
    crew: FullCrew;
}

const CrewActivitiesComponent: FunctionComponent<OwnProps & PresenterProps<CrewActivitiesPresenter>> = observer(
    ({crew, presenter}) => {
        return (
            <div className="card">
                <div className="card-title">
                    <div className="row">
                        <div className="col-12">
                            <button
                                className="btn btn-outline-primary ms-2 mt-2"
                                onClick={() => presenter.navigateToday()}
                            >
                                Today
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex justify-content-center">
                            <h5 className="d-flex flex-row">
                                <button type="button" className="btn btn-link" onClick={() => presenter.navigateBack()}>
                                    <i className="bi bi-chevron-left"></i>
                                </button>
                                <div className="calendar-daterange">
                                    {presenter.referenceDate.toLocaleString('en-us', {
                                        month: 'long',
                                        year: 'numeric',
                                    })}
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={() => presenter.navigateForward()}
                                >
                                    <i className="bi bi-chevron-right"></i>
                                </button>
                            </h5>
                        </div>
                    </div>
                </div>
                <NetworkRequestStatusView
                    result={presenter.workouts}
                    loader={() => (
                        <div className="row">
                            <Loader />
                        </div>
                    )}
                    error={() => (
                        <div className="row">
                            <Loader />
                        </div>
                    )}
                    component={() => (
                        <div className="crew-members-grid">
                            <div className="crew-members-grid__row crew-members-grid__row--with-borders">
                                <div className="crew-members-grid__cell"></div>
                                {presenter.weeks.map((week) => (
                                    <div className="crew-members-grid__cell">
                                        <div className="calendar-rsvp__header">
                                            <small>{format(week.startAt, 'eeeeee d LLL')}</small>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {crew.members
                                .filter((member) => !member.isCoach)
                                .map((member) => (
                                    <div className="crew-members-grid__row crew-members-grid__row--with-borders">
                                        <div className="crew-members-grid__cell crew-members-grid__member">
                                            {member.firstName} {member.lastName}
                                        </div>
                                        {presenter.weeks.map((week) => (
                                            <div className="crew-members-grid__cell">
                                                <div className="crew-members-grid__content">
                                                    {week.workouts
                                                        .filter((workout) => workout.user_id === member.userId)
                                                        .map((workout) => {
                                                            const distanceFormatted = formatDistanceCompact(
                                                                workout.workout_part_results.reduce(
                                                                    (workoutAcc, workoutPartResult) => {
                                                                        return workoutAcc.add(
                                                                            workoutPartResult.traveled_distance,
                                                                        );
                                                                    },
                                                                    Distance.zero(),
                                                                ),
                                                            );
                                                            return (
                                                                <Link
                                                                    className="crew-members-grid__activity"
                                                                    to={'/workouts/show/' + workout.id}
                                                                >
                                                                    {distanceFormatted.formatted}
                                                                    {distanceFormatted.unit}
                                                                </Link>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                        </div>
                    )}
                />
            </div>
        );
    },
);

export const CrewActivities = withPresenter<CrewActivitiesPresenter, OwnProps>(
    (props, component) => new CrewActivitiesPresenter(props.crew, component.network.workouts),
    CrewActivitiesComponent,
);
